import dayjs from 'dayjs';
import 'dayjs/locale/sk';

export default {
  methods: {
    state() {
      return this.$store.state
    }
  }
};
